import React from 'react';
import Navbar from '../Navbar/Navbar';
import './Impressum.css';

const Impressum = () => {
  return (
    <div className="privacy-wrapper">
      <Navbar className="terms-navbar" />
      <div className="privacy-container">
        <div className="privacy-content">
          <div className="privacy-section">
            <div className="privacy-title">Impressum</div>
            <p><strong>Angaben gemäß § 5 TMG</strong></p>
            <p>ZNOTEC GmbH<br />
            Pichelsdorfer Straße 61<br />
            13595 Berlin<br />
            Deutschland</p>
          </div>

          <div className="privacy-section">
            <div className="privacy-title">Vertreten durch die Geschäftsführer</div>
            <p>Elliot Felix Imafidon<br />
            Collins Elvis Imafidon</p>
          </div>

          <div className="privacy-section">
            <div className="privacy-title">Kontakt</div>
            <p>Telefon: +4930 35305602 | +4930 35305604<br />
            E-Mail: info@znotec.com<br />
            Webseite: www.znotec.com</p>
          </div>

          <div className="privacy-section">
            <div className="privacy-title">Registereintrag</div>
            <p>Eintragung im Handelsregister.<br />
            Registergericht: Amtsgericht Charlottenburg<br />
            Registernummer: HRB 240268 B</p>
          </div>

          <div className="privacy-section">
            <div className="privacy-title">Umsatzsteuer-ID</div>
            <p>USt.-ID: DE354709587</p>
          </div>

          <div className="privacy-section">
            <div className="privacy-title">Inhaltlich verantwortlich gemäß § 55 Abs. 2 RStV</div>
            <p>ZNOTEC GmbH<br />
            Pichelsdorfer Straße 61<br />
            13595 Berlin</p>
          </div>

          <p>Status: Mai 2025</p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
